const GAME_TIMER = 30;
const MAX_PAGES_INDEX = 29;
const MAX_WORDS_INDEX = 19;
const GAME_SCORE_BASE = 10;

export { GAME_TIMER, MAX_PAGES_INDEX, MAX_WORDS_INDEX, GAME_SCORE_BASE };
